export default "__VITE_ASSET__DI6jIICF__"